// ✅ Funkcija za setovanje page iz Redux-a / State-a
export const handleSetPaging = (page, table) => {
  if (table) {
    const maxPage = table.getPageMax();
    if (maxPage < page) {
      table.setPage(1);
    } else {
      table.setPage(page);
    }
  } else {
    console.error('Tabela nije inicijalizovana.');
  }
};
